import * as Login from "@/api/modules/php/login"; // 公共接口
import * as Commen from "@/api/modules/php/commen"; // 公共接口

import * as user from "@/api/modules/php/user"; // 用户管理
import * as ocr from "@/api/modules/php/OCR"; // 用户管理
import * as rechargeRecord from "@/api/modules/php/rechargeRecord";//钱包充值记录
import * as bills from "@/api/modules/php/bill"; // 发票管理
import * as analysis from "@/api/modules/php/analysis"; // 数据分析
import * as feedback from "@/api/modules/php/feedback"; // 意见反馈
import * as remittanceVoucher from "@/api/modules/php/remittanceVoucher"; // 汇款凭证
import * as notice from "@/api/modules/php/notice";
import * as facebook from "@/api/modules/php/facebook";
import * as relateAI from "@/api/modules/php/relateAI";

let all = {
  ...Login,
  ...Commen,
  ...user,
  ...ocr,
  ...rechargeRecord,
  ...bills,
  ...analysis,
  ...feedback,
  ...remittanceVoucher,
  ...notice,
  ...facebook,
  ...relateAI
};
export default all;
